const settingsModalComponentModule = {
  namespaced: true,
  modules: {},
  state: () => ({
    show: false,
    item: null,
    type: null,
    page: null
  }),
  getters: {},
  mutations: {
    setModal(state, { show, item, type, page }) {
      if (show) {
        state.show = show;
      }
      if (item) {
        state.item = item;
      }
      if (type) {
        state.type = type;
      }
      if (page) {
        state.page = page;
      }
    },
    clearModal(state) {
      Object.assign(state, { show: false, item: null, type: null, page: null });
    }
  },
  actions: {}
};

export default settingsModalComponentModule;
